import { render } from "./RedirectPage.vue?vue&type=template&id=3dbe1f65&scoped=true"
import script from "./RedirectPage.vue?vue&type=script&lang=js"
export * from "./RedirectPage.vue?vue&type=script&lang=js"

import "./RedirectPage.vue?vue&type=style&index=0&id=3dbe1f65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbe1f65"]])

export default __exports__